
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
const TemplateRead = () => import("./template-read.vue");
@Component({
  components: {
    TemplateRead,
  },
})
export default class Name extends Vue {
  @Prop()
  private tableData: any;
  @Watch("tableData", { immediate: true })
  private tableDataChange() {
    if (this.tableData) {
      this.data = JSON.parse(JSON.stringify(this.tableData));
    } else {
      this.data = [];
    }
  }
  private data: any = [];
}
